export function getAffiliateDataFromRegistrationLink() {
  const urlParams = new URLSearchParams(window.location.search);

  return {
    affiliateId: urlParams.get("affiliateId"),
    affiliateAccepted: urlParams.get("affiliatePartnerConfirmed") === "true",
    selectedSubsidiary: urlParams.get("selectedSubsidiary"),
  };
}
